// @ts-nocheck
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    gridItem: {
        width: [12, 6, 6, 4, 3],
    },
    cardDivider: {
        css: css`
            position: relative;
            height: 100%;
            width: 100%;
            border: 1px solid ${getColor("common.border")};
            border-radius: ${x => x.theme.design.radius.main};

            &::before {
                content: "";
                display: block;
                height: 5px;
                width: 100%;
                position: absolute;
                bottom: -1px;
                left: 0;
                background-color: transparent;
            }

            &:hover {
                border-bottom-color: transparent;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;

                &::before {
                    background-color: ${getColor("secondary.light")};
                }
            }
        `,
    },
});
